<template>
      <div class="content">
        <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="nav-bar box-horizontal mb-0">
              <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
              <div class="flex-1">
                <h3 class="m-0">Sisa Uang di Admin</h3>
                <p class="mb-0">Semua Sisa yang di terima pada bulan yang di tentukan. <span class="text-info">Klik Nama Admin untuk menambahkan Setoran.</span></p>
              </div>
            </div>
            <div class="card mt-3">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <th width="40px">No.</th>
                      <th>Admin</th>
                      <th>Total & Plggn</th>
                      <th>Setor</th>
                      <th>Sisa </th>
                      <th>Pengeluaran </th>
                      <th>Persentase </th>
                    </thead>
                      <!-- LOADING -->
                    <tbody v-show="data.loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                      <!-- DATA -->
                    <tbody v-show="!data.loading">
                      <tr v-for="(u, index) in theGet.data.List" class="pointer">
                        <td @click="link.rincian(u)">{{ index+1 }}</td>
                        <td class="text-info" @click="link.rincian(u)">{{ u.nama }}</td>
                        <td @click="link.rincianPelanggan(u)"><strong class="text-success">{{ myGlobal.ribu(u.total) }}</strong> </br><strong class="text-info"> Total Plggn : {{u.pelanggan}} <button class="btn btn-sm btn-info">Detail</button></strong></td>
                        <td @click="link.rincian(u)">{{ myGlobal.ribu(u.setor) }}</td>
                        <td @click="link.rincian(u)"><strong class="text-warning">{{ myGlobal.ribu(u.sisa) }}</strong></td>
                        <td @click="link.rincian(u)"><strong class="text-danger">{{ myGlobal.ribu(u.keluar) }}</strong></td>
                        <td @click="link.rincian(u)">{{u.persen}}% - {{ myGlobal.ribu((( parseInt(u.total) / 100 ) * parseInt(u.persen))) }}</td>
                      </tr>
                      <!-- NULL -->
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
        </div>
        </div>

        <div class="modal" v-show="data.rincianPopup">
          <div class="overlay"></div>
          <div class="modal-dialog modal-data" role="document">

            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">RINCIAN TRANSAKSI</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.rincianPopup = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="box-horizontal">
                  <div class="d-block flex-1">
                    <h3 class="m-0 mb-1">{{data.rincianTitle}}</h3>
                    <p class="m-0 mb-2 text-warning">Sisa {{myGlobal.ribu(data.rincianSisa)}}</p>
                  </div>
                  <button class="btn btn-info" @click="link.tambahSetoran()">Tambah Setoran</button>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <th width="40px">No.</th>
                      <th>Keterangan</th>
                      <th>Jenis</th>
                      <th>Total</th>
                      <th>Oleh</th>
                      <th>Tanggal</th>
                    </thead>
                      <!-- LOADING -->
                    <tbody v-show="data.loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                      <!-- DATA -->
                    <tbody v-show="!data.loadingRincian">
                      <tr v-for="(u, index) in theGet.data.ListRincian">
                        <td>{{index + 1}}</td>
                        <td>{{u.keterangan}}</td>
                        <td style="text-transform: uppercase;">
                          <span class="text-danger" v-if="u.type == 'keluar'">{{u.type}}</span>
                          <span class="text-warning" v-else-if="u.type == 'setor'">{{u.type}}</span>
                          <span v-else>{{u.type}}</span>
                        </td>
                        <td>{{myGlobal.ribu(u.jumlah)}}</td>
                        <td>{{u.by_admin}}</td>
                        <td>{{u.jam}} || {{myGlobal.tglIndo(u.tanggal)}}</td>
                      </tr>
                      <!-- NULL -->
                      <tr v-if="theGet.data.ListRincian == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal" v-show="data.rincianPopupPelanggan">
          <div class="overlay"></div>
          <div class="modal-dialog modal-data" role="document">

            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">RINCIAN PELANGGAN</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.rincianPopupPelanggan = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" style="overflow: auto; max-height: 500px;">
                <div class="box-horizontal">
                  <div class="d-block flex-1">
                    <h3 class="m-0 mb-1">{{data.rincianTitlePelanggan}}</h3>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Area</th>
                      <th>Paket</th>
                      <th>Total</th>
                      <th>Tanggal</th>
                    </thead>
                      <!-- LOADING -->
                    <tbody v-show="data.loadingPelanggan">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                      <!-- DATA -->
                    <tbody v-show="!data.loadingPelanggan">
                      <tr v-for="(u, index) in data.pelanggan">
                        <td>{{index + 1}}</td>
                        <td>{{u.user.unama}}<br>{{u.user.wa}}</td>
                        <td>{{u.area}}</td>
                        <td>{{u.user.pnama}}</td>
                        <td>{{myGlobal.ribu(u.user.paket_tarif)}}</td>
                        <td>{{u.user.bayar_jam}} || {{myGlobal.tglIndo(u.user.bayar_tanggal)}}</td>
                      </tr>
                      <!-- NULL -->
                      <tr v-if="data.pelanggan == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import router from '@/router'

export default {
  name: 'Beranda',
	components: { 
    "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
      loading: true,

      rincianPopup: false,

      rincianTitle: "",
      rincianSisa: 0,
      loadingRincian: true,
      idTagihDetail: null,
      namaTagihDetail: null,

      rincianPopupPelanggan: false,
      rincianTitlePelanggan: null,
      idTagihDetailPelanggan: null,
      loadingPelanggan: true,
      pelanggan: []
    })

    const theGet = {
      data: reactive({
          List: [],
          ListRincian: [],
          Total: "0",
      }),
      datae() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            bulan: sessionStorage.getItem('bulanIdBase'),
            tahun: sessionStorage.getItem('tahunBase'),
            filter: "masuk"
        };
    
        var apiUrl = inter.SisaUang();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          data.loading = false;

          if (x.status == true) {
            this.data.List = x.data;
            this.data.Total = x.pesan.masuk;
          
          } else {
            theGet.data.List = null;
          }
        })
      },
      rincian(idKangtagih) {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            bulan: sessionStorage.getItem('bulanIdBase'),
            tahun: sessionStorage.getItem('tahunBase'),
            idtagih: idKangtagih
        };
    
        var apiUrl = inter.SisaRincian();
        myGlobal.call(datax,apiUrl).then(x => {
          data.loadingRincian = false;

          data.loading = false;
          if (x.status == true) {
            this.data.ListRincian = x.data;
            this.data.Total = x.pesan.masuk;
          } else {
            theGet.data.ListRincian = null;
          }
        })
      },
      rincianPelanggan(nama) {
        data.pelanggan = [];

        var datax = new FormData();
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        datax.append('admin', nama);
        datax.append('bulan', "0");
        datax.append('tahun', sessionStorage.getItem('tahunBase'));
        datax.append('type', "lunas");
        datax.append('area', null);
        datax.append('tanggal', null);
        datax.append('by', "admin");
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(datax,apiUrl).then(x => {
          data.loadingPelanggan = false;
          
          if (x.status == true) {

            data.pelanggan = x.data;

            // console.log(JSON.stringify(data.pelanggan));

          } else {

            //alert(x.pesan);
            data.pelanggan = null;
            
          }
        })
      }
    }

    const link = {
      rincian(u) {
        // console.log(JSON.stringify(u));
        data.rincianPopup = true;
        theGet.rincian(u.id)
        data.rincianTitle = u.nama;
        data.rincianSisa = u.sisa;

        data.idTagihDetail = u.id;
        data.namaTagihDetail = u.nama;
      },
      
      rincianPelanggan(u) {
        data.rincianPopupPelanggan = true;
        data.rincianTitlePelanggan = u.nama;
        data.idTagihDetailPelanggan = u.id;
        theGet.rincianPelanggan(u.nama)
      },

      tambahSetoran() {
        router.push({ 
          name: 'pembukuan-pengeluaran-tambah',
          params: {
            admin: data.idTagihDetail,
            nama: data.namaTagihDetail
          } 
        }); 
      }
    }


    return {
      data,
      myGlobal,
      theGet,
      link
    }
  },
  mounted () {
    document.title = "Pemasukkan";

    this.data.namaQ = sessionStorage.getItem('admin');
    this.theGet.datae();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/sisa.vue